import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestSettingsPatch = {
    path: "/settings",
    method: RouteHttpVerb.PATCH
};
